import {
  SERVICE_AREAS_GET_BEGIN,
  SERVICE_AREAS_GET_SUCCESS,
  SERVICE_AREAS_GET_FAILURE,
  SERVICE_AREA_SET_SUCCESS,
  SELECTED_SERVICE_AREA_REFRESH_SUCCESS,
} from './serviceAreasActions';

const initialState = {
  selectedServiceArea: null,
  serviceAreas: null,
  loading: false,
  error: null
};

export default function serviceAreasReducer(state = initialState, action) {
  switch(action.type) {
    case SERVICE_AREAS_GET_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case SERVICE_AREAS_GET_SUCCESS:
      saveSelectedServiceAreaToLocalStorage(state.selectedServiceArea || action.payload.serviceAreas[0]);

      return {
        ...state,
        loading: false,
        serviceAreas: action.payload.serviceAreas,
        selectedServiceArea: state.selectedServiceArea || action.payload.serviceAreas[0],
      };
    case SERVICE_AREA_SET_SUCCESS:
      saveSelectedServiceAreaToLocalStorage(action.payload.serviceArea);

      return {
        ...state,
        selectedServiceArea: action.payload.serviceArea
      };
    case SERVICE_AREAS_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        serviceAreas: null
      };
    case SELECTED_SERVICE_AREA_REFRESH_SUCCESS:
      const selectedArea = getSelectedServiceAreaFromLocalStorage();

      if (!selectedArea) {
        return state;
      } else {
        return {
          ...state,
          loading: false,
          selectedServiceArea: selectedArea,
        };
      }
    default:
      return state;
  }
}

function saveSelectedServiceAreaToLocalStorage(serviceArea) {
  localStorage.setItem('selectedServiceArea', JSON.stringify(serviceArea));
}

function getSelectedServiceAreaFromLocalStorage() {
  const serviceArea = localStorage.getItem('selectedServiceArea');

  return JSON.parse(serviceArea);
}